import React, { useEffect } from 'react';
import { useAppSelector } from 'redux/store/hooks';
import TokenStore from 'lib/token-store';

const withVisitsLogging = (App) => {
  const WithVisitsLogging = (props) => {
    const homePageRevision = useAppSelector(
      (state) => state.homePageRevision?.revision,
    );
    const hub = useAppSelector((state) => state.hub?.hub);

    const fetchCurrentSessionInformation = async () => {
      const host = `${window.location.protocol}//${window.location.host}`;
      const res = await fetch(`${host}/session_info`);
      const data = await res.json();

      const { session_id, user_id, user_type } = data.data.attributes;

      return {
        session_id,
        user_id,
        user_type,
      };
    };

    const mapUrlToItemType = (url) => {
      if (url?.startsWith('/admin/sites/editors/home-page/live-preview'))
        return 'homepage';
      if (url?.includes('/admin/sites/editors/hub-page/')) return 'hubpage';
      return '';
    };

    const getPageId = (url) => {
      const type = mapUrlToItemType(url);
      if (type === 'homepage') return homePageRevision?.oldHomePageId;
      if (type === 'hubpage') return hub?.id;
      return undefined;
    };

    const getVisitedUrl = (url) => {
      const host = `${window.location.protocol}//${window.location.host}`;
      const previewPrefix = '/admin/sites/editors/home-page/live-preview';
      if (url?.startsWith(previewPrefix)) {
        const formattedPath = url.replace(previewPrefix, '');
        return host + formattedPath;
      }
      return url;
    };

    const logVisit = async (
      session_id,
      user_id,
      user_type,
      visitedUrl,
      referer,
      userAgent,
    ) => {
      const itemType = mapUrlToItemType(visitedUrl);
      const pageId = getPageId(visitedUrl);

      if (!pageId || !itemType) return;

      const body = {
        data: {
          attributes: {
            page_id: pageId,
            item_type: itemType,
            session_id,
            user_id,
            user_type,
            visited_url: getVisitedUrl(visitedUrl),
            user_agent: userAgent,
          },
        },
        referrer: referer,
      };

      const host = `${window.location.protocol}//${window.location.host}`;
      const token = TokenStore.apiToken;
      const headers = {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      };

      await fetch(`${host}/api/v2/logger`, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      });
    };

    useEffect(() => {
      const run = async () => {
        const query = new URLSearchParams(window.location.search);
        const isDraft = query.get('draft') === 'true';
        if (isDraft) return;

        const visitedUrl = window.location.pathname;
        const referer = document.referrer;
        const userAgent = navigator.userAgent;

        const { session_id, user_id, user_type } =
          await fetchCurrentSessionInformation();

        await logVisit(
          session_id,
          user_id,
          user_type,
          visitedUrl,
          referer,
          userAgent,
        );
      };

      run();
    }, []);

    return <App {...props} />;
  };

  return WithVisitsLogging;
};

export default withVisitsLogging;
